import React, { useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Form, message } from "antd";
import { ReactComponent as Proton } from "../../assets/svg/Proton.svg";
import { PrimaryButton } from "../../Components/StyledComponents/Button";
import { P } from "../../Components/StyledComponents/Paragraph";
import { PrimaryFlex } from "../../Components/StyledComponents/Flex";
import { PrimaryInput } from "../../Components/StyledComponents/Input";
import { PrimaryTooltip } from "../../Components/StyledComponents/Tooltip";
import RegisterPageBg from "../../assets/png/RegisterPageBg.png";
import transition from "../../Transition";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import EntryPageCarousel from "../../Components/EntryPageCarousel/EntryPageCarousel";
import { SimpleFlex } from "../../Components/StyledComponents/SimpleFlex";
import { sendPasswordResetEmail } from "../../redux/slice/ForgotPassword/forgotPassword";
import { useTranslation } from "react-i18next";
import "./ForgotPassword.css";
import LanguageSwitcher from "../../Components/LanguageSwitcher/LanguageSwitcher";

function ForgotPassword() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await dispatch(sendPasswordResetEmail(values.username)).unwrap();
      messageApi.open({
        type: "success",
        content: t("resetPwdSuccess"),
      });
      setLoading(false);
      // navigate("/proton");
    } catch (error) {
      messageApi.open({
        type: "error",
        content: t("resetPwdFailed"),
      });
      setLoading(false);
    }
  };

  return (
    <div
      className="container"
      style={{
        background: `url("${RegisterPageBg}"), lightgray 50% / cover no-repeat`,
      }}
    >
      {contextHolder}
      <SimpleFlex
        justifycontent="flex-end"
        height="auto"
        width="auto"
        backgroundcolor="transparent"
        position="absolute"
        className="positioning"
      >
        <LanguageSwitcher />
      </SimpleFlex>
      <div
        style={{
          position: "absolute",
          width: "100vw",
          height: "100vh",
          zIndex: 1,
          opacity: 0.85,
          background: "#21223D",
        }}
      ></div>
      <div className="d-flex h-100">
        <Card
          style={{
            width: "auto",
            margin: "auto",
            zIndex: 2,
          }}
        >
          <PrimaryFlex flexdirection="column" gap="1rem">
            <PrimaryFlex justifycontent="space-between">
              <Proton />
            </PrimaryFlex>
            <PrimaryFlex gap="6.25rem">
              <PrimaryFlex>
                <EntryPageCarousel />
              </PrimaryFlex>
              <Form
                name="normal_login"
                className="login-form"
                onFinish={onFinish}
              >
                <PrimaryFlex flexdirection="column" gap="1.875rem">
                  <PrimaryFlex flexdirection="column">
                    <P fontWeight="bolder" fontsize="2.5rem">
                      {t("forgotPassword")}
                    </P>
                  </PrimaryFlex>
                  <PrimaryFlex flexdirection="column" gap="1rem">
                    <SimpleFlex flexdirection="column">
                      <P
                        fontWeight="300"
                        fontsize="0.938rem"
                        color="var(--nav-color)"
                        margin="0 0 0.5rem 1rem"
                      >
                        {t("emailID")}
                        <PrimaryTooltip title="Mandatory" placement="top">
                          <InfoCircleOutlined
                            style={{ marginLeft: "0.25rem" }}
                          />
                        </PrimaryTooltip>
                      </P>
                      <Form.Item
                        name="username"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Username!",
                          },
                          {
                            type: "email",
                            message: "The input is not valid E-mail!",
                          },
                        ]}
                      >
                        <PrimaryInput
                          width="22.875rem"
                          height="3.375rem"
                          placeholder={t("userName")}
                        />
                      </Form.Item>
                    </SimpleFlex>

                    <Form.Item>
                      <PrimaryButton
                        fontWeight="600"
                        padding="0 0.625rem"
                        width="22.875rem"
                        height="3.125rem"
                        fontsize="1.125rem"
                        htmlType="submit"
                        loading={loading}
                        justifycontent="center"
                      >
                        {t("submit")}
                      </PrimaryButton>
                    </Form.Item>
                  </PrimaryFlex>
                </PrimaryFlex>
              </Form>
            </PrimaryFlex>
          </PrimaryFlex>
        </Card>
      </div>
    </div>
  );
}
export default transition(ForgotPassword);
